import { css } from '@vebox/etui-system';

function makeMedia(mediaQuery) {
  return (literals, ...interpolations) => css`
    @media ${mediaQuery} {
      ${css(literals, ...interpolations)}
    }
  `;
}
const mediaQuery = (query, theme) => {
  const breakpoints = ['xs', 'sm', 'md', 'lg'].reduce((current, item, index) => {
    current[item] = index === 0 ? `0px` : theme.breakpoints[index];
    return current;
  }, {});
  return Object.keys(breakpoints).reduce((accumulator, label) => {
    const size = breakpoints[label];
    accumulator[label] = (strings, ...interpolations) => makeMedia(`${query}: ${size}px`)(strings, ...interpolations);
    return accumulator;
  }, {});
};
const mediaMax = theme => mediaQuery('max-width', theme);
const mediaMin = theme => mediaQuery('min-width', theme);

export { makeMedia, mediaMax, mediaMin };
